import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const className: AdminBlockTypeAttribute = {
  label: 'Container class name',
  key: 'className',
  inputType: AdminBlockAttributeInputType.STRING_INPUT,
};

export default className;
